import { render, staticRenderFns } from "./RoomSelect.vue?vue&type=template&id=6b60b9fa"
import script from "./RoomSelect.vue?vue&type=script&lang=js"
export * from "./RoomSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports